// extracted by mini-css-extract-plugin
export default {"wrapper__opened":"styles_wrapper__opened__SiIpa"};